// extracted by mini-css-extract-plugin
export default {"main_cont":"styles_main_cont__JHUek","contact":"styles_contact__GIVAq","contact_flex":"styles_contact_flex__apZGo","fadein":"styles_fadein__8iR+i","visible":"styles_visible__ZJPOL"};